import { useCheckAnyPolicyHasStatus } from '../../../components/hooks/queries/policies/useCheckAnyPolicyHasStatus';
import {
  EXPIRED_STATUS,
  RENEWED_STATUS,
} from '../../../console/_statics/policy.statics';

export function useIsEligibleForFreeCtaas(): boolean {
  const hasExpiredPolicy = useCheckAnyPolicyHasStatus(EXPIRED_STATUS);
  const hasRenewedPolicy = useCheckAnyPolicyHasStatus(RENEWED_STATUS);

  return !(hasRenewedPolicy || hasExpiredPolicy);
}
